import { Descriptions, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { type BmwModuleSpecsFragment } from '../../../../api/fragments/BmwModuleSpecs';

export type AuthorizationProps = {
    module: BmwModuleSpecsFragment;
};

const Authorization = ({ module }: AuthorizationProps) => {
    const { t } = useTranslation('bmwModuleDetails');

    if (!module?.bmwSetting?.authorization) {
        return null;
    }

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('bmwModuleDetails:fields.authorization.accessKey.label')}>
                    {module.bmwSetting.authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('bmwModuleDetails:fields.authorization.secretKey.label')}>
                    {module.bmwSetting.authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default Authorization;
